import { ComponentProps } from 'react';

import { Trigger as RadixTrigger, TabsTriggerProps } from '@radix-ui/react-tabs';
import { twMerge } from 'tailwind-merge';

import { Button } from '../../../Button';

interface TriggerProps extends Omit<ComponentProps<typeof Button>, 'value' | 'variant'>, TabsTriggerProps {
  readonly active?: boolean;
}

function Trigger({ value, className, active, children, disabled, ...props }: TriggerProps) {
  return (
    <div className={twMerge('relative', className)}>
      <RadixTrigger asChild value={value} className="peer outline-none" disabled={disabled}>
        <Button
          variant="nude"
          size="none"
          disabled={disabled}
          className="rounded-lg px-3 py-2 font-medium text-brand hover:text-light-blue-500 focus:ring-inset"
          {...props}
        >
          {children}
        </Button>
      </RadixTrigger>
      {active ? (
        <div className="mx-3 h-1 view-transition-[underscore-tab] peer-radix-state-active:bg-brand peer-radix-state-inactive:bg-transparent" />
      ) : (
        <div className="mx-3 h-1" />
      )}
    </div>
  );
}

export { Trigger };
